import xss from 'xss'

export const getSanitizedHtml = (htmlStr: string): string => {
  return htmlStr ? xss(htmlStr) : ''
}
